import React, { useState, useEffect } from "react";
import "../css/Login.css";
import "../css/Model.css";
import api from "../api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import CompanyLogo from "../assets/Images/CompName.svg";
import VelaKoda from "../assets/Images/LoginLogo.svg";

const images = [
  // "/img/superadminbg1.png",
  "/img/superadminbg2.png",
  "/img/superadminbg5.png",
  "/img/superadminbg3.png",
  "/img/superadminbg4.png",
  "/img/superadminbg5.png",
];

const ResetPassword = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const token = sessionStorage.getItem("resetToken");

  const validatePassword = (password) => {
    if (password.length < 6) return TOAST_MESSAGES.AUTH.PASSWORD_TOO_SHORT;
    if (!/[A-Z]/.test(password))
      return TOAST_MESSAGES.AUTH.PASSWORD_NEEDS_UPPER;
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      return TOAST_MESSAGES.AUTH.PASSWORD_NEEDS_SPECIAL;
    return null;
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!token) {
      showErrorToast("Reset session token missing. Please login again.");
      navigate("/"); // redirect to login
      return;
    }

    const validationError = validatePassword(newPassword);
    if (validationError) {
      showErrorToast(validationError);
      return;
    }

    if (newPassword !== confirmPassword) {
      showErrorToast(TOAST_MESSAGES.AUTH.PASSWORDS_DO_NOT_MATCH);
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/reset-password`,
        { newPassword, confirmPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      showSuccessToast(TOAST_MESSAGES.AUTH.PASSWORD_RESET_SUCCESS);

      // sessionStorage.removeItem("resetToken");
      // Clear all old tokens
      localStorage.clear();
      sessionStorage.clear();

      // Redirect user to login page
      navigate("/", { replace: true });

      // navigate("/successful");
    } catch (err) {
      const errorMsg = err.response?.data?.message;

      if (err.response?.status === 401) {
        showErrorToast("Session expired. Please login again.");
        navigate("/");
      } else if (err.response?.status === 400 && errorMsg) {
        // <-- HERE: show backend validation errors including "same password"
        showErrorToast(errorMsg);
      } else if (err.response?.status === 500) {
        showErrorToast(
          "Server error while resetting password. Please try again later."
        );
      } else {
        showErrorToast(
          err.response?.data?.message ||
            TOAST_MESSAGES.AUTH.PASSWORD_RESET_FAILED
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Clear all stored data
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to login page
    navigate("/", { replace: true });
  };

  return (
    <div className="login-container">
      <div className="login-left">
        {images.map((img, index) => (
          <div
            key={index}
            className={`bg-slide ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          >
            {/* Desktop Logo placed on the image */}
            <img src={VelaKoda} alt="logo" className="slide-logo" />
          </div>
        ))}
      </div>
      <div className="login-right d-flex flex-column justify-content-center align-items-start w-100">
        {/* Fixed Logo */}
        <div className="logo-wrapper">
          <img
            className="zerobox-logo"
            // src="/asset/login-logo.png"
            src={CompanyLogo}
            alt="VelaKoda Logo"
          />
        </div>

        <form
          className="login-form p-4  rounded-3 mx-auto mt-1"
          onSubmit={handleReset}
        >
          <h3 className="mb-3 text-center refresh-prompts fw-bolder">
            Reset Password
          </h3>

          <p className="text-center login-p refresh-prompts">
            New password must be different from previous password.
          </p>

          {/* New Password */}
          <div className=" rounded w-100 mb-3">
            <div className="input-group custom-search-group">
              <input
                type={showNewPassword ? "text" : "password"}
                className="form-control"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                <i
                  className={`bi ${
                    showNewPassword ? "bi-eye" : "bi-eye-slash"
                  }`}
                ></i>
              </span>
            </div>
          </div>

          {/* Confirm Password */}
          <div className=" rounded w-100 mb-3">
            <div className="input-group custom-search-group">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <i
                  className={`bi ${
                    showConfirmPassword ? "bi-eye" : "bi-eye-slash"
                  }`}
                ></i>
              </span>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row gap-2 w-100 mt-3">
            <button
              type="button"
              className="cancle-btn flex-fill"
              onClick={handleCancel}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="custom-btn flex-fill"
              disabled={loading}
            >
              {loading ? "Resetting..." : "Continue"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
